import {Injectable} from '@angular/core';
import {ItemSummaryItemService} from './item-summary-item.service';
import {Observable} from 'rxjs';
import {Asset} from '../domain/item';
import {HttpClient} from '@angular/common/http';
import {appConfig} from "../app.config";
import {HttpRequestErrorHandler} from "@rbaip/ui-component";
import {catchError, map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ItemSummaryEquipmentService extends ItemSummaryItemService {

  constructor(private http: HttpClient) {
    super();
  }

  public duplicateSellerTracking(sellerTrackingCode: string, itemId: number, assetPackageId?: number): Observable<any> {
    return undefined;
  }

  duplicateSerialNumber(serialNumber: string, itemId: number, assetPackageId?: number): Observable<any> {
    return undefined;
  }

  getAsset(assetId: number): void {
  }

  getAssetPhoto(itemId: number): Observable<any> {
    return undefined;
  }

  reconsignAsset(equipId: number, contractId: number): Observable<any> {
    const url = `/api/equipment/${equipId}/reconsign?contractId=${contractId}`;
    return this.http.post<any>(url, '', appConfig.httpOptions)
      .pipe(
        catchError(HttpRequestErrorHandler.handleError('', false))
      );
  }

  resellAbandonedEquip(equipId: number): Observable<any> {
    const url =  `/api/equip/${equipId}/abandoned/resell`;
    return this.http.post<any>(url, '', appConfig.httpOptions)
      .pipe(
        catchError(HttpRequestErrorHandler.handleError('resellAbandonedEquip', false))
      );
  }

  public resellNotSoldAssets(contractId: number, assets?: Asset[]): Observable<any> {
    const url = `/api/equip/not-sold/resell?contractId=${contractId}`;
    return this.http.post<any>(url, assets, appConfig.httpOptions)
      .pipe(
        catchError(HttpRequestErrorHandler.handleError('resellNotSoldAssets', false))
      );
  }

  saveAssetBudget(equipId: number, rnrBudget: number, haulingBudget: number): Observable<any> {
    let url = '/api/equip/:equipId/rnrBudget/:rnrBudget/haulingBudget/:haulingBudget/updateBudget';
    url = url.replace(':equipId', String(equipId) );
    url = url.replace(':rnrBudget', rnrBudget > 0 ? rnrBudget.toString() : '0');
    url = url.replace(':haulingBudget', haulingBudget > 0 ? haulingBudget.toString() : '0');
    const body = '';
    return this.http.put(url, body, appConfig.httpOptions)
      .pipe(
        catchError(HttpRequestErrorHandler.handleError('updatebudget', null))
      );
  }

  saveAssetInformation(asset: Asset): Observable<any> {
   const url = `/api/equip/${asset.equipId}/asset-info`;
   return this.http.put<any>(url, asset, appConfig.httpOptions)
      .pipe(
        map(response => response.data),
        catchError(HttpRequestErrorHandler.handleError('saveEquipInfo', false))
      );
  }

  saveAssetSaleInfo(asset: Asset): Observable<any> {
    return undefined;
  }

  public markAsReviewed(equipIds: number[]) : Observable<any>{
    let url = '/api/equips/mark-as-reviewed';
    return this.http.put(url, equipIds, appConfig.httpOptions)
      .pipe(
        catchError(HttpRequestErrorHandler.handleError('mark-as-reviewed', null))
      );
  }

  public isCheckListChanged(equipId: number, assetTypeId: number): Observable<any> {
    const url = `/api/equip/${equipId}/assettype/${assetTypeId}/checklist`;
    return this.http.get(url, appConfig.httpOptions)
      .pipe(
        catchError(HttpRequestErrorHandler.handleError('isCheckListChanged', {}))
      );
  }

}
